import BetDrawerButton from "app/components/BetDrawerButton/BetDrawerButton";
import { IconEmptyFavorite, IconFavorite } from "app/components/Icon/Icon";
import { FormattedMessage } from "react-intl";
import "./EventFavouritesScreen.scss";

const EventFavoritesScreen: React.FC = () => {
  return (
    <div className="event-favorites">
      <div className="event-favorites__header">
        <div>
          <IconFavorite className="event-favorites__header__favorite-icon" />
        </div>
        <div>
          <FormattedMessage tagName="span" id="events-favorites" /> (0)
        </div>
      </div>
      <div className="event-favorites__content--empty">
        <IconEmptyFavorite className="event-favorites__header__favorite-icon" />
        <div>
          <FormattedMessage tagName="span" id="favourites-coming-soon" />
        </div>
      </div>

      <BetDrawerButton />
    </div>
  );
};

export default EventFavoritesScreen;
